export const HIDE_MOBILE_BANNER = 'LS_DESIGN_FEEDBACK/HIDE_MOBILE_BANNER';
